import React, { useEffect, useState } from "react";
import {
  Col,
  Row,
  Card,
  CardBody,
  CardTitle, 
} from "reactstrap";
import { Link } from "react-router-dom";

import { nanoid } from "nanoid";
import './custom.css';

import cardImg1 from '../../assets/images/small/knovia14.png';
import cardImg2 from '../../assets/images/small/knovia5.png';
import cardImg3 from '../../assets/images/small/knovia8.jpeg';
import cardImg4 from '../../assets/images/small/knovia9.png';
import cardImg5 from '../../assets/images/small/knovia15.jpeg';
import cardImg6 from '../../assets/images/small/knovia1.jpeg';

// Main Activity Comp Component
const ActivityComp = (props) => {

  /*---- Card Prompts ----*/

  const [cardPrompts, setCardPrompts] = useState([]);

  const promptInput = [
    { order: 1, image: cardImg1, title:"即時文本翻譯", text: "立刻試試 TheChart.AI 的生成式 AI 翻譯", url: "/dashboard-translate" },
    { order: 2, image: cardImg2, title:"檔案翻譯", text: "可以幫我把檔案的內容翻譯完，放到原本的格式中嗎？", url: "/projects-list" },
    { order: 3, image: cardImg3, title:"語音翻譯", text: "和外語人士溝通時，使用 AI 來輔助吧！", url: "/speech-to-text" },
    { order: 4, image: cardImg4, title:"客服對話", text: "能不能讓 AI 用我想要的方式，參考我給的資料來回答問題？", url: "/chatbot-menu" },
    { order: 5, image: cardImg5, title:"LINE 串接", text: "AI 也能回覆 LINE 官方帳號，再也不怕半夜漏回到訊息了", url: "/chatbot-menu" },
    { order: 6, image: cardImg6, title:"生成QA集", text: "TheChart.AI 讓你的網站內容立即變成 AI 參考的問答集！", url: "/qa-create" },
  ]

  useEffect(() => {

    const prompts = promptInput.map((prompt, index) => (

        <Col key={nanoid()} sm={4}>

          <Link to={prompt.url}>

            <div 
              className={`card card-prompt`} 
              style={{ "--bs-card-border-radius": "1rem 1rem 1rem 1rem" }}
            >
              <div className="no-gutters align-items-center row">

                {/* Image */}
                <div className="col-md-12">
                  <img 
                    src={prompt.image} 
                    style={{ width: "auto", borderRadius:"1rem 1rem 0rem 0rem" }} 
                    alt={`image_${prompt.order}`}
                    className="img-fluid card-img" 
                  />
                </div>

                {/* Text */}
                <div className="col-md-12">
                  <div 
                    className={`card-body card-body${index+1}`}
                    style={{ minHeight: "6.7rem" }}
                  >
                    <div className="card-title">{prompt.title}</div>
                    <p className="card-text">{prompt.text}</p>
                  </div>
                </div>

              </div>
            </div>

          </Link>

        </Col>
        
    ));

    setCardPrompts(prompts);

  }, []);

  /*---- Card Prompts Tail ----*/



  /*--- Return Component ---*/

  return (
    <React.Fragment>

      <Card>
        <CardBody>

          {/* Card Prompts */}
          <Row>

            {/* Card Title */}
            <Col sm={12}>
              <CardTitle className="mb-3" style={{ "marginTop":"0.5rem" }}>
                TheChart.AI 可以做什麼？
              </CardTitle>
            </Col>

            {/* Card Body */}
            <Col sm={12}>
              <Row className="row-prompt">
                {cardPrompts}
              </Row>
            </Col>

          </Row>

        </CardBody>
      </Card>

    </React.Fragment>
  );
};

export default ActivityComp;

